package co.uk.sacursoftware.ssinventory.util

import kotlinx.browser.window

actual class KeyValueStorage actual constructor() {
    actual fun putString(key: String, value: String) {
        window.localStorage.setItem(key, value)
    }

    actual fun getString(key: String): String? {
        return window.localStorage.getItem(key)
    }

    actual fun remove(key: String) {
        window.localStorage.removeItem(key)
    }
}
